<template>
  <div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
  import echarts from 'echarts';
  require('echarts/theme/macarons'); // echarts 主题
  const animationDuration = 3000;
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '100%'
      }
    },
    data() {
      return {
        chart: null
      };
    },
    mounted() {
      this.initChart();
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose();
      this.chart = null;
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons');
        
		let data=[80,100,123,128,377,877,11];
		let data1=[10,0,13,128,577,177,121];
		let xdata=['类型1','类型2','类型3','类型4','类型5','类型6','类型7'];
        this.chart.setOption({
			title: {
				text: '类型统计',
				textAlign: 'left',
				//backgroundColor: '#fff',
				 textStyle: {//主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
				                fontFamily: 'Arial, Verdana, sans...',
				                fontSize: 12,
				                fontStyle: 'normal',
				                fontWeight: 'normal',
								color:'#333'
				            },
			},
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
		  legend: {
			  // icon: 'square',
		      data:['学生','老师'],		
					
		    },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
		  calculable : true,
          xAxis: [{
            type: 'category',
            data: xdata,
            axisTick: {
              alignWithLabel: true
            },
			
          }],
          yAxis: [{
            type: 'value',
			
			splitLine: {
			        show: false
			      }
          }],
          series: [{
            name: '学生',
            type: 'bar',
            // stack: 'vistors',
            barWidth: '20%',
            data: data,
            itemStyle:{
                    normal:{
                      color:'#2EC7C9',
					  label : {show: true, position: 'top'}
                    }
                  }
          },{
            name: '老师',
            type: 'bar',
            // stack: 'vistors',
            barWidth: '20%',
            data: data1,
			itemStyle:{
			        normal:{
			          color:'#FFB981',
					  label : {show: true, position: 'top'}
			        }
			      }
          },],
        })
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/editor/barChart.vue